import { useEffect, useState } from "react";
import { Plug, X } from "lucide-react";
import { api } from "../lib/api.js";
import { McpManager } from "./McpManager.js";

export function Settings({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [voice, setVoice] = useState<string>("");
  const [voices, setVoices] = useState<string[]>([]);
  const [saved, setSaved] = useState(false);
  const [enrollCode, setEnrollCode] = useState<string | null>(null);
  const [mcpOpen, setMcpOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    api
      .getSettings()
      .then((d) => {
        setVoices(d.voices);
        setVoice(d.settings.voice || d.voices[0] || "marin");
      })
      .catch(() => {});
  }, [open]);

  if (!open) return null;

  async function change(v: string) {
    setVoice(v);
    await api.patchSettings({ voice: v }).catch(() => {});
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <span>Settings</span>
          <button className="ghost icon" onClick={onClose} aria-label="Close">
            <X size={16} />
          </button>
        </div>
        <div className="modal-body">
          <label className="field">
            <span className="field-label">Voice</span>
            <select value={voice} onChange={(e) => change(e.target.value)}>
              {voices.map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </label>
          <p className="field-hint">
            {saved ? "Saved. " : ""}Voice applies to the next voice session (reconnect to hear it).
          </p>

          <div className="field" style={{ marginTop: 20 }}>
            <span className="field-label">MCP servers</span>
            <button className="ghost" onClick={() => setMcpOpen(true)}>
              <Plug size={14} /> Find, add &amp; manage servers
            </button>
            <p className="field-hint">
              Connect external tools (GitHub, Linear, browsers, databases…) for the worker to use.
            </p>
          </div>

          <div className="field" style={{ marginTop: 20 }}>
            <span className="field-label">Add a device</span>
            <button
              className="ghost"
              onClick={async () => {
                const r = await api.enrollStart().catch(() => null);
                setEnrollCode(r?.code ?? "error");
              }}
            >
              Generate code
            </button>
            {enrollCode && (
              <p className="field-hint">
                On the new device, choose “Set up this device with a code” and enter:{" "}
                <strong style={{ color: "var(--text)", fontSize: 18, letterSpacing: 2 }}>{enrollCode}</strong>
                <br />
                Valid for 10 minutes.
              </p>
            )}
          </div>
        </div>
      </div>
      <McpManager open={mcpOpen} onClose={() => setMcpOpen(false)} />
    </div>
  );
}
